// extracted by mini-css-extract-plugin
export default {"pageBackground":"AwaitingPage_pageBackground__1JYiG","text":"AwaitingPage_text__50Ks-"};